import React, { PropsWithChildren } from 'react';

import { BoxArgs } from './index';
import { StyledBox } from './styles';

export const Box = ({ children, dataLocator, ...commonProps }: PropsWithChildren<BoxArgs>) => {
    return (
        <StyledBox data-locator={dataLocator} {...commonProps}>
            {children}
        </StyledBox>
    );
};
